import { Component, OnInit, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import {EMPTY } from 'rxjs'
import {catchError, retry, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ResolutionCodingService } from '../services/resolution-coding.service';
@Component({
    selector: 'app-login-preloader',
    templateUrl: './login-preloader.component.html',
    styleUrls: ['./login-preloader.component.css'],
    standalone: false
})

// this.router.navigateByUrl("/home")

export class LoginPreloaderComponent implements OnInit {
  private authService = inject(AuthService);
  router = inject(Router);
  private resolutionCodingService = inject(ResolutionCodingService);

  skinPath = environment.assets;
  logoPath = "/assets/images/all_logos/" + environment.logoFile;
  failed = false;

  ngOnInit(): void {
    this.setLocalUserAccount();
  }

  setLocalUserAccount() {
    this.authService.getUserAccount()
    .pipe(
      retry(3),
      catchError(()=>{
        this.failed = true
        return EMPTY
      }),
      shareReplay()
    )
    .subscribe( (result) => {
      this.authService.setUser(result);
      this.resolutionCodingService.init();
      this.router.navigateByUrl("/home")
    }, () => {
      // intentionally empty error handler
    });
  }
  
  getLogo(){
    if (environment.logoFile){
      return "assets/images/all_logos" + environment.logoFile
    }
    else{
      return "assets/images/all_logos/logo_MAAP-Logon.png"
    }
    
  }
}
